import constants from 'src/config/constants.ts'
import { Survey } from 'src/store/models/channel/index.js'

const surveyMixin = {
  methods: {
    createNewUserOption () {
      return {
        is_chosen: false,
        has_user_option: true,
        name: this.$t('survey.create.free_text.survey_placeholder'),
        uuid: this.$uuid()
      }
    },

    createNewFreetextOption () {
      return {
        is_freetext_question_option: true,
        uuid: this.$uuid()
      }
    },

    cancelUserOption (cancelledOption, question = false) {
      // if the user has typed an answer and the option name has changed, we want to prevent the deselection
      const notDefaultOptionName = cancelledOption.option.name !== this.$t('survey.create.free_text.survey_placeholder')
      const hasTypedAnswer = !!cancelledOption.answer.length
      const preventDeselection = (hasTypedAnswer && notDefaultOptionName) || notDefaultOptionName
      if (question) return this.multiQuestionOptionChanged(question, cancelledOption.option.uuid, preventDeselection)
      this.singleQuestionOptionChanged(cancelledOption.option.uuid, preventDeselection)
    },

    questionOptionChanged (allSelectedValues = {}, selectedQuestion, selectedOptionUuid, preventUserOptionDeselection = false, isFreeTextQuestion = false) {
      if (!this.isMultiAnswerableQuestion(selectedQuestion) || isFreeTextQuestion) {
        const wasSelectedBefore = allSelectedValues[selectedQuestion.uuid]?.options?.includes(selectedOptionUuid)
        if (wasSelectedBefore && !preventUserOptionDeselection && !isFreeTextQuestion) {
          // delete from variable if the previously selected option is now unselected, use destructuring syntax to do it
          const { [selectedQuestion.uuid]: _, ...remainingSelectedValue } = allSelectedValues
          return remainingSelectedValue
        }

        return {
          ...allSelectedValues,
          [selectedQuestion.uuid]: { options: [selectedOptionUuid] }
        }
      }

      if (preventUserOptionDeselection) return { ...allSelectedValues }

      const changedOption = allSelectedValues[selectedQuestion.uuid]
        ? allSelectedValues[selectedQuestion.uuid].options.includes(selectedOptionUuid)
          ? allSelectedValues[selectedQuestion.uuid].options.filter(uuid => uuid !== selectedOptionUuid)
          : [...allSelectedValues[selectedQuestion.uuid].options, selectedOptionUuid]
        : [selectedOptionUuid]

      if (!changedOption.length) {
        // delete from variable if there is no option selected, use destructuring syntax to do it
        const { [selectedQuestion.uuid]: _, ...remainingSelectedValue } = allSelectedValues
        return remainingSelectedValue
      }
      return {
        ...allSelectedValues,
        [selectedQuestion.uuid]: {
          options: changedOption,
          ...(allSelectedValues[selectedQuestion.uuid]?.new_option) && { new_option: allSelectedValues[selectedQuestion.uuid]?.new_option }
        }
      }
    },

    isMultiAnswerableQuestion (question) {
      if (!question) return false
      return question.type === constants.survey.question_type.MULTIPLE_CHOICE
    },

    async submitAnswer (surveyID, selectedOptions, freetextOptionUuidList = [], questions) {
      this.$wait.start(`voting-${surveyID}`)
      try {
        const payload = {
          votes: Object.keys(selectedOptions).map(questionUuid => {
            const questionType = questions.find(question => question.uuid === questionUuid).type
            const optionValues = selectedOptions[questionUuid]
            return {
              question_uuid: questionUuid,
              // we need to remove the freetext & user options from the payload
              ...(questionType !== constants.survey.question_type.FREE_TEXT) &&
                { options: optionValues.options.filter(optionUuid => !freetextOptionUuidList.includes(optionUuid)) },
              // instead, it's values should be placed in the "new_option" field
              ...(optionValues.new_option) && { new_option: optionValues.new_option }
            }
          })
        }

        const res = await Survey.vote(surveyID, payload)
        if (!res || !res.data) return
        return res.data
      } finally {
        this.$wait.end(`voting-${surveyID}`)
      }
    },

    isQuestionTypeFreetext (question) {
      return question.type === constants.survey.question_type.FREE_TEXT
    }
  }
}

export default surveyMixin
